const GoogleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      className="inline-block"
    >
      <path
        d="M6.41996 15.4656L5.59721 18.537L2.59008 18.6006C1.69139 16.9338 1.18164 15.0266 1.18164 13C1.18164 11.0403 1.65825 9.1922 2.50306 7.56494H2.50371L5.1809 8.05576L6.35366 10.7169C6.10821 11.4325 5.97442 12.2007 5.97442 13C5.97451 13.8675 6.13166 14.6987 6.41996 15.4656Z"
        fill="#FBBB00"
      />
      <path
        d="M24.6116 10.7921C24.7474 11.507 24.8181 12.2453 24.8181 12.9999C24.8181 13.846 24.7292 14.6713 24.5597 15.4675C23.9844 18.1765 22.4811 20.5421 20.3987 22.2161L20.398 22.2155L17.026 22.0434L16.5487 19.0642C17.9305 18.2538 19.0104 16.9856 19.5793 15.4675H13.2598V10.7921H19.6715H24.6116Z"
        fill="#518EF8"
      />
      <path
        d="M20.3981 22.2156L20.3988 22.2162C18.3735 23.8441 15.8007 24.8181 13.0001 24.8181C8.49942 24.8181 4.58645 22.3026 2.59033 18.6006L6.42021 15.4656C7.41824 18.1292 9.98773 20.0253 13.0001 20.0253C14.2949 20.0253 15.5079 19.6753 16.5488 19.0643L20.3981 22.2156Z"
        fill="#28B446"
      />
      <path
        d="M20.5432 3.90253L16.7146 7.03693C15.6374 6.36357 14.364 5.97459 12.9997 5.97459C9.91916 5.97459 7.30162 7.95769 6.35358 10.7168L2.50358 7.56487H2.50293C4.46983 3.77267 8.43215 1.18176 12.9997 1.18176C15.8672 1.18176 18.4964 2.2032 20.5432 3.90253Z"
        fill="#F14336"
      />
    </svg>
  );
};

export default GoogleIcon;
